<script>
    import { onMount, getContext } from 'svelte'

    const setupFullscreenJS = getContext('setupFullscreenJS')

    onMount(async () => {
        setupFullscreenJS()

        const bgImg = document.querySelectorAll('.bg-img')
        bgImg.forEach(img => {
            const src = img.getAttribute('data-image-src');
            img.style.backgroundImage = `url('${src}')`;
            img.style.backgroundRepeat = 'no-repeat';
            img.style.backgroundPosition = 'center';
            img.style.backgroundSize = 'cover';
        });
	});
</script>

<!-- BEGIN OF page main content -->
<main class="page-main main-anim fullpg pagedetail" id="mainpage">
    <slot></slot>
</main>
<!-- END OF page main content -->